export default "__VITE_ASSET__DR_li9PP__"